import React from 'react';

const Filter = ({ label, options = [], disabled, name, onChange, selected }) => {
  return (
    <div className="col-lg-3 col-md-12 pl-0">
      <label style={{ fontSize: 12 }}>{label}</label>
      {disabled ? (
        <select className="form-control" name={name} disabled onChange={onChange}>
          {options.length == 0 ? (
            <option>Pilih {label}</option>
          ) : (
            options.map((item, i) => {
              return item.disabled ? (
                <option key={i} disabled selected={selected === item.value} value={item.value}>
                  {item.label}
                </option>
              ) : (
                <option key={i} selected={selected === item.value} value={item.value}>
                  {item.label}
                </option>
              );
            })
          )}
        </select>
      ) : (
        <select className="form-control" name={name} onChange={onChange}>
          {options.length == 0 ? (
            <option>Pilih {label}</option>
          ) : (
            options.map((item, i) => {
              return item.disabled ? (
                <option key={i} disabled selected={selected === item.value} value={item.value}>
                  {item.label}
                </option>
              ) : (
                <option key={i} selected={selected === item.value} value={item.value}>
                  {item.label}
                </option>
              );
            })
          )}
        </select>
      )}
    </div>
  );
};

export default Filter;
